import React from 'react'

import { ArrowRight as ArrowRightIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function SubscribeBar() {
  return (
    <a href="/subscription" className="timer-strip--top-bar">
      <div className="timer-strip timer-strip--subscription">
        <div className="timer-row timer-strip__subscription-row">
          <div className="timer-strip__item timer-strip__item--content timer-strip__item--content-no-timer">
            <span className="timer-strip__content--full">
              Access a curated library of top-quality models included in your subscription.
            </span>
            <span className="timer-strip__content--short">
              Get top-quality 3D models with your subscription.
            </span>
          </div>

          <div className="timer-strip__cta">
            Get Subscription
            <ArrowRightIcon width="16" height="16" />
          </div>
        </div>
      </div>
    </a>
  )
}

export default SubscribeBar
